import "./App.css";
import StandupContainer from "./StandupContainer";

function App() {
  return (
    <div className="App">
      <StandupContainer />
    </div>
  );
}

export default App;
